import { lazy, Suspense } from "react"; // PROSCORE_GLOBAL_PERF_LAZY_20261028
const LegalPage = lazy(() => import("./pages/LegalLot11B"));
import SeoHead from "./components/SeoHead";
const CompetitionStanding = lazy(() => import("./pages/CompetitionStanding"));
const Competitions = lazy(() => import("./pages/Competitions"));
import "@/App.css";
import "@/premium-refresh.css";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { AccessProvider } from "@/context/AccessContext";
import { MotionConfig } from "framer-motion";
import { Layout } from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";
const Home = lazy(() => import("@/pages/Home"));
const Matches = lazy(() => import("@/pages/Matches"));
const MatchDetail = lazy(() => import("@/pages/MatchDetail"));
const Pricing = lazy(() => import("@/pages/Pricing"));
const CouponPro = lazy(() => import("@/pages/CouponPro"));
const Account = lazy(() => import("@/pages/Account"));
const AdminDashboard = lazy(() => import("@/pages/AdminDashboard")); // PROSCORE_ADMIN_DASHBOARD_LOT10_20261027
const Support = lazy(() => import("@/pages/Support"));

function App() {
  return (
    <div className="App">
      <MotionConfig reducedMotion="user">
      <AccessProvider>
        <BrowserRouter>
          <Layout>
            <SeoHead />
            <Suspense fallback={<div role="status" className="mx-auto max-w-lg px-4 py-14 text-center text-slate-300">Chargement de la page…</div>}><Routes>
              <Route path="/" element={<Home />} />
          <Route path="/competitions" element={<Competitions />} />
          <Route path="/competitions/:competitionId" element={<CompetitionStanding />} />
          <Route path="/matches" element={<Matches />} />
              <Route path="/matchs" element={<Matches />} />
              <Route path="/matchs/:id" element={<MatchDetail />} />
              <Route path="/offres" element={<Pricing />} />
              <Route path="/coupon" element={<CouponPro />} />
              <Route path="/compte" element={<Account />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/assistance" element={<Support />} />
        <Route path="/confidentialite" element={<LegalPage type="privacy" />} />
        <Route path="/conditions-utilisation" element={<LegalPage type="terms" />} />
        <Route path="/mentions-legales" element={<LegalPage type="legal" />} />
        <Route path="/cookies" element={<LegalPage type="cookies" />} />
              <Route path="*" element={<div className="mx-auto max-w-lg px-4 py-20 text-center"><h1 className="font-heading text-3xl text-white">Page introuvable</h1><Link to="/" className="mt-6 inline-block text-gold-300">Retour à l’accueil</Link></div>} />
            </Routes></Suspense>
          </Layout>
          <Toaster position="top-center" theme="dark" richColors />
        </BrowserRouter>
      </AccessProvider>
      </MotionConfig>
    </div>
  );
}

export default App;
